import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { InventoryOutputDetailModel } from 'src/app/models/inventory/inventory-output-detail.model';
import { RentalStockModel } from 'src/app/models/rental/rental-stock-response.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ArticleSelectionTableModel } from 'src/app/models/tables/archive/article-selection-table.model';
import { InventoryOutputDetailCaptureTableModel } from 'src/app/models/tables/inventory/inventory-output-detail-capture-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InventoryOutputDetailService {
  constructor(private _httpClient: HttpClient) { }

  createInventoryOutputDetail(inventoryOutputDetailContract: InventoryOutputDetailModel): Observable<InventoryOutputDetailModel> {
    return this._httpClient.post<InventoryOutputDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutputDetail.CreateInventoryOutputDetail}`,
      inventoryOutputDetailContract);
  }

  createSomeDetails(rentalStocks: Array<InventoryOutputDetailModel>): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutputDetail.CreateSomeDetails}`, rentalStocks);
  }

  deleteInventoryOutputDetail(inventoryOutputDetailId: number): Observable<InventoryOutputDetailModel> {
    return this._httpClient.delete<InventoryOutputDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutputDetail.DeleteInventoryOutputDetail}/${inventoryOutputDetailId}`);
  }

  deleteSomeDetails(inventoryOutputDetailIds: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutputDetail.DeleteSomeDetails}`,
      inventoryOutputDetailIds);
  }

  exportDetailConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutputDetail.ExportDetailConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  exportPendingOrderConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutputDetail.ExportPendingOrderConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  getAllInventoryOutputDetailsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutputDetail.GetAllInventoryOutputDetailsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getAllPendingOrdersWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutputDetail.GetAllPendingOrdersWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getArticlesForOutputs(storeId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<ArticleSelectionTableModel>> {
    const params = new HttpParams().set('storeId', storeId).set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<ArticleSelectionTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutputDetail.GetArticlesForOutputs}`,
      filters, { params: params }
    );
  }

  // getColumnsForArticles(): Observable<ColumnResponseModel[]> {
  //   return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutputDetail.GetColumnsForArticles}`);
  // }

  getColumnsForCaptureTable(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutputDetail.GetColumnsForCaptureTableAsync}`);
  }

  getColumnsForDetailConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutputDetail.GetColumnsForDetailConsultation}`);
  }

  getColumnsForPendingOrdersConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutputDetail.GetColumnsForPendingOrdersConsultation}`);
  }

  getColumnsArticleInternalOrder(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutputDetail.GetColumnsArticleInternalOrder}`);
  }

  getColumnsForListStocksInShop(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutputDetail.GetColumnsForListStocksInShop}`);
  }

  getInventoryOutputDetailById(inventoryOutputDetailId: number): Observable<InventoryOutputDetailModel> {
    return this._httpClient.get<InventoryOutputDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutputDetail.GetInventoryOutputDetailById}/${inventoryOutputDetailId}`);
  }

  getInventoryOutputDetailByKeys(inventoryOutputId: number, storeId: number, articleId: number): Observable<InventoryOutputDetailModel> {
    return this._httpClient.get<InventoryOutputDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutputDetail.GetInventoryOutputDetailByKeys}/${inventoryOutputId}/${storeId}/${articleId}`);
  }

  getInventoryOutputDetailByOutputId(inventoryOutputId: number): Observable<Array<InventoryOutputDetailModel>> {
    return this._httpClient.get<Array<InventoryOutputDetailModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutputDetail.GetInventoryOutputDetailsByOutputId}/${inventoryOutputId}`)
  }

  getInventoryOutputDetailsForCaptureTable(page: number, limit: number, columnSort: string | null, ascendant: boolean, inventoryOutputId: number): Observable<PagedResponseModel<InventoryOutputDetailCaptureTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '')
      .set('ascendant', ascendant).set('inventoryOutputId', inventoryOutputId);

    return this._httpClient.get<PagedResponseModel<InventoryOutputDetailCaptureTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutputDetail.GetInventoryOutputDetailsForCaptureTable}`,
      { params: params }
    );
  }

  getListArticlesInInternalOrder(inventoryOutputId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<RentalStockModel>> {
    const params = new HttpParams().set('inventoryOutputId', inventoryOutputId).set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<RentalStockModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutputDetail.GetListArticlesInInternalOrder}`,
      filters, { params: params }
    );
  }

  getListArticlesStocksInShop(inventoryOutputId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<RentalStockModel>> {
    const params = new HttpParams().set('inventoryOutputId', inventoryOutputId).set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<RentalStockModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutputDetail.GetListStocksInShop}`,
      filters, { params: params }
    );
  }

  getStocksByArticleIdStoreId(rentalStockModel: RentalStockModel): Observable<number> {
    return this._httpClient.post<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutputDetail.GetStocksByArticleIdStoreId}`,
      rentalStockModel);
  }

  updateInventoryOutputDetail(inventoryOutputDetailContract: InventoryOutputDetailModel): Observable<InventoryOutputDetailModel> {
    return this._httpClient.put<InventoryOutputDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryOutputDetail.UpdateInventoryOutputDetail}`,
      inventoryOutputDetailContract);
  }
}

